import _ from 'lodash';

// import 'mapbox.js';

class ThematicLayer {
    constructor (layer, options) {
        const defaults = {
            name: '',
            layerName: '',
            title: '',
            area: null,
            lowerCorner: null,
            upperCorner: null,
            map: null
        };

        this.options = _.assign({}, defaults, options);

        this.layer = layer;
        this.name = this.options.name;
        this.layerBound = this._getLayerBound();

        this.htmlButton = `<input type="checkbox" id="btn${this.options.layerName}">${this.options.title}`;
        const urlLegend = `http://geosrv.neocom.info:8080/geoserver/${this.options.workspace}/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=`;
        const divLegend = `<div>${this.options.title}<img src="${urlLegend}${this.options.name}"class="img-responsive" alt="Responsive image"/></div>`;

        this.legend = L.control({ position: 'bottomleft' });

        this.legend.onAdd = map => {
            const div = L.DomUtil.create('div', 'layer-legend');
            div.innerHTML += divLegend;
            return div;
        };
    }

    show () {
        this.layer.addTo(this.options.map);
        return this._addLegend();
    }

    hide () {
        if (this.options.map.hasLayer(this.layer)) {
            this.options.map.removeLayer(this.layer);
            return this._removeLegend();
        }
    }

    setOpacity (value) {
        return this.layer.setOpacity(value);
    }

    _addLegend () {
        return this.legend.addTo(this.options.map);
    }

    _removeLegend () {
        try {
            return this.legend.removeFrom(this.options.map);
        } catch (err) {
            console.log(err);
        }
    }

    _getLayerBound () {
        const longLatUp = this.options.upperCorner.split(' ');
        const northEast = L.latLng(parseFloat(longLatUp[1]), parseFloat(longLatUp[0]));
        const longLatLower = this.options.lowerCorner.split(' ');
        const southWest = L.latLng(parseFloat(longLatLower[1]), parseFloat(longLatLower[0]));

        return L.latLngBounds(southWest, northEast);
    }
}

export default ThematicLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/Leaflet/ThematicLayer.js